import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Header, Segment, Divider, Grid} from 'semantic-ui-react';
import _ from 'lodash';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import VisibilitySensor from 'react-visibility-sensor';
import * as math from 'mathjs';
import {calculateOverallActivityScore} from 'componentLibrary/deprecated/PanelScoreSummary';

export const buildContent = (scoreDetails, scoreAverages) => {
  const content = [];
  const sortedDetails = _.sortBy(scoreDetails, 'category');
  let currentCategory = null;
  _.forEach(sortedDetails, (dataObject) => {
    if (currentCategory !== dataObject.category) {
      if (currentCategory) {
        content.push(<Divider />);
      }
      currentCategory = dataObject.category;
      content.push(
        <Grid.Row>
          <Grid.Column width="16">
            <Header as="h4">{_.capitalize(_.lowerCase(currentCategory))}</Header>
          </Grid.Column>
        </Grid.Row>
      );
      content.push(
        <Grid.Row>
          <Grid.Column width="6">Reviewer</Grid.Column>
          <Grid.Column width="10">
            <strong>Score</strong>
            <br />
            <strong>Comment</strong>
          </Grid.Column>
        </Grid.Row>
      );
    }
    content.push(
      <Grid.Row>
        <Grid.Column width="6">{dataObject.reviewer}</Grid.Column>
        <Grid.Column width="10">
          <strong>{dataObject.score.text}</strong>
          <br />
          <strong>{dataObject.justification}</strong>
        </Grid.Column>
      </Grid.Row>
    );
  });
  if (!_.isEmpty(scoreAverages)) {
    content.push(
      <React.Fragment>
        <Grid.Row>
          <Grid.Column width="16">
            <Divider />
            <Header as="h4">Final scores</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="6">Panel score average</Grid.Column>
          <Grid.Column width="10">
            <strong>{scoreAverages.panelScore}</strong>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="6">Pre-score</Grid.Column>
          <Grid.Column width="10">
            <strong>{scoreAverages.preScore}</strong>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="6">Cumulative score</Grid.Column>
          <Grid.Column width="10">
            <strong>{scoreAverages.overallScore}</strong>
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    );
  }
  return content;
};

export const getScoreDetails = (panelReview, activity) => {
  const scoreDetails = [];
  _.forEach(panelReview, (scoreObject) => {
    if (scoreObject.activity && scoreObject.activity === activity) {
      scoreDetails.push(scoreObject);
    }
  });
  return scoreDetails;
};

export const getScoreAverages = (scores, activity, weights) => {
  const scoreAverages = {};
  let panelScore = null;
  let preScore = null;
  let activityName = null;
  _.forEach(scores.panelScores, (scoreObject) => {
    if (scoreObject.activityName && scoreObject.activityName === activity) {
      panelScore = scoreObject.score;
      activityName = scoreObject.activityName;
    }
  });
  _.forEach(scores.preScores, (scoreObject) => {
    if (scoreObject.activityName && scoreObject.activityName === activity) {
      preScore = scoreObject.score;
    }
  });

  weights = {'Recruitment and Retention of Volunteer Firefighters': '0.3'};
  const preScoreWeight = _.get(weights, activityName);
  if (panelScore && preScore) {
    scoreAverages.overallScore = calculateOverallActivityScore(
      preScore,
      panelScore,
      preScoreWeight
    );
    scoreAverages.panelScore = panelScore.toFixed(2);
    scoreAverages.preScore = preScore.toFixed(2);
  } else if (panelScore) {
    scoreAverages.panelScore = panelScore.toFixed(2);
    scoreAverages.overallScore = panelScore.toFixed(2);
    scoreAverages.preScore = 'N/A';
  } else if (preScore) {
    scoreAverages.overallScore = 'N/A';
    scoreAverages.panelScore = 'N/A';
    scoreAverages.preScore = preScore.toFixed(2);
  }
  return scoreAverages;
};

export class PanelScoresForActivity extends React.Component {
  onVisibilityChange = (isVisible) => {
    if (this.props.handleVisibilityChange)
      this.props.handleVisibilityChange(this.props.spot, isVisible);
  };

  render() {
    const {scoreDetails, scoreAverages} = this.props;

    if (_.isEmpty(scoreDetails) && _.isEmpty(scoreAverages)) return null;
    else {
      const content = (
        <React.Fragment>
          <Header id={this.props.title} name={this.props.title} as="h2">
            {this.props.title}
          </Header>
          <Segment>
            <Grid>{buildContent(scoreDetails, scoreAverages)}</Grid>
          </Segment>
        </React.Fragment>
      );
      if (this.props.samePageNav) {
        return (
          <VisibilitySensor
            onChange={this.onVisibilityChange}
            partialVisibility={true}
            delayedCall={true}
            offset={{top: 150, bottom: 150}}
          >
            {content}
          </VisibilitySensor>
        );
      } else return content;
    }
  }
}

export const mapStateToProps = (state, props) => {
  const {context} = state.dynamicComponent;
  let scoreDetails = [];
  let scoreAverages = {};
  const {prescoreWeight} = '';
  if (_.get(context, 'panelReview.loading') === false) {
    scoreDetails = getScoreDetails(context.panelReview, props.activity);
  }

  if (_.get(context, 'scores.loading') === false) {
    scoreAverages = getScoreAverages(
      context.scores,
      props.scoresActivity,
      prescoreWeight
    );
  }
  return {
    scoreDetails: scoreDetails,
    scoreAverages: scoreAverages,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  saveDataBasedTitles: (dataBasedTitles) =>
    dispatch(DynamicComponentActions.saveDataBasedTitles(dataBasedTitles)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelScoresForActivity);
